import { c as _c } from "react/compiler-runtime";
import React, { FC, SVGProps } from 'react';
export const Share: FC<SVGProps<SVGSVGElement>> = props => {
  const $ = _c(5);
  let t0;
  let t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <path d="M5.38948 7.984H4.45648C2.42148 7.984 0.771484 9.634 0.771484 11.669L0.771484 16.544C0.771484 18.578 2.42148 20.228 4.45648 20.228H15.5865C17.6215 20.228 19.2715 18.578 19.2715 16.544V11.659C19.2715 9.63 17.6265 7.984 15.5975 7.984L14.6545 7.984" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />;
    t1 = <path d="M10.0214 1.1905V13.2315" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />;
    t2 = <path d="M7.10626 4.1188L10.0213 1.1908L12.9373 4.1188" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />;
    $[0] = t0;
    $[1] = t1;
    $[2] = t2;
  } else {
    t0 = $[0];
    t1 = $[1];
    t2 = $[2];
  }
  let t3;
  if ($[3] !== props) {
    t3 = <svg {...props} fill="currentColor" stroke="currentColor" width="21" height="21" viewBox="0 0 21 21" xmlns="http://www.w3.org/2000/svg">{t0}{t1}{t2}</svg>;
    $[3] = props;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  return t3;
};